export const DUMMY_PROFILE = {
  "visi-misi": {
    id: {
      judul: "Visi Misi dan Legalitas",
      deskripsi: `
        <h3>Visi</h3>
        <p>Mewujudkan lembaga pendidikan yang berlandaskan nilai-nilai tasawuf untuk melahirkan generasi unggul mendiri.</p>
        <br/>
        <h3>Misi</h3>
        <ul>
          <li>Melahirkan generasi unggul yang berakhlakul karimah, berkecerdasan multi dan mandiri.</li>
          <li>Meningkatkan sumber daya manusia yang memiliki etos kerja produktif dan profesional berlandaskan nilai Iman, Islam dan Ihsan.</li>
          <li>Mewujudkan lingkungan pendidikan yang sehat, disiplin, dan religius sesuai tradisi pesantren.</li>
        </ul>
        <br/>
        <h3>Tujuan</h3>
        <p>Pendidikan Idrisiyyah bertujuan untuk membentuk pribadi yang sholeh dan sholehah dengan aqidah yang lurus serta menjadi agen dakwah Islam ke seluruh umat manusia melalui berbagai jenjang pendidikan dari Prasekolah hingga Perguruan Tinggi (Ma'had Aly).</p>
      `,
    },
    en: {
      judul: "Vision Mission and Legality",
      deskripsi: `
        <h3>Vision</h3>
        <p>Realizing an educational institution based on Sufism values to produce an excellent and independent generation.</p>
        <br/>
        <h3>Mission</h3>
        <ul>
          <li>Producing an excellent generation with noble character, multi-intelligence, and independence.</li>
          <li>Improving human resources with a productive and professional work ethic based on the values of Iman, Islam, and Ihsan.</li>
          <li>Creating a healthy, disciplined, and religious educational environment in accordance with pesantren traditions.</li>
        </ul>
        <br/>
        <h3>Purpose</h3>
        <p>Idrisiyyah Education aims to form pious individuals with a straight and firm creed and to become agents of Islamic propagation to all humanity through various levels of education from Preschool to Higher Education (Ma'had Aly).</p>
      `,
    },
    ar: {
      judul: "الرؤية والمهمة والقانونية",
      deskripsi: `
        <h3>الرؤية</h3>
        <p>تحقيق مؤسسة تعليمية قائمة على قيم التصوف لتخريج جيل متميز ومستقل.</p>
        <br/>
        <h3>المهمة</h3>
        <ul>
          <li>تخريج جيل متميز ذي أخلاق كريمة وذكاء متعدد واستقلالية.</li>
          <li>تحسين الموارد البشرية ذات أخلاقيات العمل الإنتاجية والمهنية القائمة على قيم الإيمان والإسلام والإحسان.</li>
          <li>خلق بيئة تعليمية صحية ومنضبطة ودينية وفقاً لتقاليد المعهد.</li>
        </ul>
        <br/>
        <h3>الهدف</h3>
        <p>يهدف تعليم إدريسية إلى تكوين أفراد صالحين وصالحات بعقيدة مستقيمة وثابتة وأن يصبحوا وكلاء للدعوة الإسلامية للبشرية جمعاء من خلال مستويات تعليمية مختلفة من مرحلة ما قبل المدرسة إلى التعليم العالي (معهد عالي).</p>
      `,
    },
  },
  transformasi: {
    id: {
      judul: "Transformasi Pendidikan Idrisiyyah",
      deskripsi: `
        <p>Pendidikan Idrisiyyah terus bertransformasi untuk menjawab tantangan zaman tanpa meninggalkan akar tradisi pesantren yang kuat. Transformasi ini mencakup digitalisasi sistem pembelajaran, pengembangan kurikulum yang relevan, serta peningkatan kualitas SDM.</p>
        <br/>
        <h3>Fokus Transformasi</h3>
        <ul>
          <li><strong>Digitalisasi:</strong> Implementasi Smart Class dan sistem manajemen sekolah digital.</li>
          <li><strong>Globalisasi:</strong> Kerjasama internasional dan penguatan bahasa asing (Arab & Inggris).</li>
          <li><strong>Kemandirian:</strong> Pengembangan unit bisnis sekolah untuk mendukung operasional pendidikan.</li>
        </ul>
      `,
    },
    en: {
      judul: "Idrisiyyah Education Transformation",
      deskripsi: `
        <p>Idrisiyyah Education continues to transform to answer modern challenges without leaving its strong pesantren traditional roots. This transformation includes digitalization of learning systems, development of relevant curricula, and improving HR quality.</p>
        <br/>
        <h3>Transformation Focus</h3>
        <ul>
          <li><strong>Digitalization:</strong> Implementation of Smart Class and digital school management systems.</li>
          <li><strong>Globalization:</strong> International cooperation and strengthening of foreign languages (Arabic & English).</li>
          <li><strong>Independence:</strong> Development of school business units to support educational operations.</li>
        </ul>
      `,
    },
    ar: {
      judul: "التحول في تعليم إدريسية",
      deskripsi: `
        <p>يستمر تعليم إدريسية في التحول لمواجهة تحديات العصر دون التخلي عن جذوره التقليدية العميقة في المعهد. ويشمل هذا التحول رقمنة أنظمة التعلم، وتطوير المناهج الدراسية ذات الصلة، وتحسين جودة الموارد البشرية.</p>
        <br/>
        <h3>تركيز التحول</h3>
        <ul>
          <li><strong>الرقمنة:</strong> تنفيذ الفصول الذكية وأنظمة إدارة المدارس الرقمية.</li>
          <li><strong>العولمة:</strong> التعاون الدولي وتعزيز اللغات الأجنبية (العربية والإنجليزية).</li>
          <li><strong>الاستقلال:</strong> تطوير وحدات الأعمال المدرسية لدعم العمليات التعليمية.</li>
        </ul>
      `,
    },
  },
  kurikulum: {
    id: {
      judul: "Kurikulum Terpadu Idrisiyyah",
      deskripsi: `
        <p>Kurikulum Pendidikan Idrisiyyah dirancang secara unik dengan memadukan kurikulum nasional, kurikulum khas pesantren, dan nilai-nilai tasawuf. Hal ini bertujuan untuk menciptakan keseimbangan antara kecerdasan intelektual, emosional, dan spiritual.</p>
        <br/>
        <h3>Pilar Kurikulum</h3>
        <ul>
          <li><strong>Kurikulum Nasional:</strong> Sesuai dengan standar Kemendikbudristek/Kemenag.</li>
          <li><strong>Kurikulum Kepesantrenan:</strong> Penguasaan kitab kuning, tahfidz Al-Qur'an, dan bahasa Arab.</li>
          <li><strong>Kurikulum Karakter:</strong> Penanaman adab dan nilai-nilai spiritual dalam keseharian.</li>
        </ul>
      `,
    },
    en: {
      judul: "Idrisiyyah Integrated Curriculum",
      deskripsi: `
        <p>The Idrisiyyah Education Curriculum is uniquely designed by blending national curriculum, typical pesantren curriculum, and Sufism values. This aims to create a balance between intellectual, emotional, and spiritual intelligence.</p>
        <br/>
        <h3>Curriculum Pillars</h3>
        <ul>
          <li><strong>National Curriculum:</strong> In accordance with Ministry of Education/Ministry of Religion standards.</li>
          <li><strong>Pesantren Curriculum:</strong> Mastery of classic texts (Kitab Kuning), Quran memorization, and Arabic.</li>
          <li><strong>Character Curriculum:</strong> Instilling etiquette (Adab) and spiritual values in daily life.</li>
        </ul>
      `,
    },
    ar: {
      judul: "منهج إدريسية المتكامل",
      deskripsi: `
        <p>تم تصميم منهج تعليم إدريسية بشكل فريد من خلال مزج المنهج الوطني، ومنهج المعهد التقليدي، وقيم التصوف. يهدف هذا إلى خلق توازن بين الذكاء الفكري والعاطفي والروحي.</p>
        <br/>
        <h3>أركان المنهج</h3>
        <ul>
          <li><strong>المنهج الوطني:</strong> وفقاً لمعايير وزارة التعليم / وزارة الشؤون الدينية.</li>
          <li><strong>منهج المعهد:</strong> إتقان الكتب الصفراء، وحفظ القرآن الكريم، واللغة العربية.</li>
          <li><strong>منهج الشخصية:</strong> غرس الأدب والقيم الروحية في الحياة اليومية.</li>
        </ul>
      `,
    },
  },
  alumni: {
    id: {
      judul: "Ikatan Alumni Idrisiyyah",
      deskripsi: `
        <p>Alumni Idrisiyyah tersebar di berbagai wilayah dan berkiprah di berbagai bidang, mulai dari pendidikan, dakwah, profesional, hingga kewirausahaan. Ikatan Alumni berfungsi sebagai wadah silaturahmi dan kontribusi bagi kemajuan lembaga.</p>
        <br/>
        <p>Kami bangga dengan para lulusan kami yang terus membawa nilai-nilai Iman, Islam, dan Ihsan di tengah masyarakat luas. Program alumni mencakup pertemuan rutin, sharing session karir, dan pengabdian masyarakat.</p>
      `,
    },
    en: {
      judul: "Idrisiyyah Alumni Association",
      deskripsi: `
        <p>Idrisiyyah alumni are spread across various regions and active in various fields, ranging from education, dakwah, professionals, to entrepreneurship. The Alumni Association serves as a forum for friendship and contribution to the advancement of the institution.</p>
        <br/>
        <p>We are proud of our graduates who continue to carry the values of Iman, Islam, and Ihsan in the wider community. Alumni programs include regular meetings, career sharing sessions, and community service.</p>
      `,
    },
    ar: {
      judul: "رابطة خريجي إدريسية",
      deskripsi: `
        <p>ينتشر خريجو إدريسية في مناطق مختلفة وينشطون في مجالات متنوعة، من التعليم والدعوة والمهن الحرة إلى ريادة الأعمال. وتعمل رابطة الخريجين كمنتدى للتواصل والمساهمة في تقدم المؤسسة.</p>
        <br/>
        <p>نحن فخورون بخريجينا الذين يواصلون حمل قيم الإيمان والإسلام والإحسان في المجتمع الواسع. وتشمل برامج الخريجين الاجتماعات المنتظمة، وجلسات تبادل الخبرات المهنية، وخدمة المجتمع.</p>
      `,
    },
  },
  sejarah: {
    id: {
      judul: "Sejarah Lembaga Pendidikan Idrisiyyah",
      deskripsi: `
        <p>Lembaga Pendidikan Idrisiyyah memiliki akar sejarah yang panjang, bermula dari semangat dakwah dan tarbiyah yang dibawa oleh para Mursyid Tarekat Idrisiyyah. Seiring dengan perkembangan zaman, kebutuhan akan pendidikan formal yang mengintegrasikan nilai-nilai spiritual (tasawuf) dengan disiplin ilmu modern menjadi semakin krusial.</p>
        <br/>
        <p>Dimulai dengan pengajian-pengajian tradisional di Zawiyah, kini Idrisiyyah telah mengelola berbagai jenjang pendidikan formal, mulai dari Pendidikan Anak Usia Dini (PAUD), Sekolah Dasar Islam Terpadu (SDIT), Sekolah Menengah (SMPIT, SMAIT, SMK), hingga jenjang Perguruan Tinggi yang dikenal dengan Ma'had Aly Idrisiyyah.</p>
      `,
    },
    en: {
      judul: "History of Idrisiyyah Educational Institution",
      deskripsi: `
        <p>Idrisiyyah Educational Institution has long historical roots, starting from the spirit of dakwah and tarbiyah brought by the Mursyids of the Idrisiyyah Sufi Order. Along with the times, the need for formal education that integrates spiritual values (Sufism) with modern disciplines has become increasingly crucial.</p>
        <br/>
        <p>Starting with traditional studies in Zawiyah, Idrisiyyah now manages various levels of formal education, from Early Childhood Education (PAUD), Integrated Islamic Elementary School (SDIT), Middle School (SMPIT, SMAIT, SMK), to the Higher Education level known as Ma'had Aly Idrisiyyah.</p>
      `,
    },
    ar: {
      judul: "تاريخ مؤسسة إدريسية التعليمية",
      deskripsi: `
        <p>تمتلك مؤسسة إدريسية التعليمية جذوراً تاريخية طويلة، بدأت من روح الدعوة والتربية التي حملها مرشدو الطريقة الإدريسية. ومع مرور الزمن، أصبحت الحاجة إلى تعليم رسمي يدمج القيم الروحية (التصوف) مع التخصصات العلمية الحديثة أمراً بالغ الأهمية.</p>
        <br/>
        <p>بدءاً من الدراسات التقليدية في الزاوية، تدير إدريسية الآن مستويات مختلفة من التعليم الرسمي، من التعليم في مرحلة الطفولة المبكرة (PAUD)، والمدرسة الابتدائية الإسلامية المتكاملة (SDIT)، والمدرسة المتوسطة (SMPIT، SMAIT، SMK)، إلى مستوى التعليم العالي المعروف باسم معهد عالي إدريسية.</p>
      `,
    },
  },
  organisasi: {
    id: {
      judul: "Struktur Organisasi Pendidikan Idrisiyyah",
      deskripsi: `
        <p>Struktur Organisasi Divisi Pendidikan Idrisiyyah dirancang untuk memastikan tata kelola lembaga yang profesional, transparan, dan akuntabel.</p>
        <br/>
        <h3>Struktur Utama</h3>
        <ul>
          <li><strong>Ketua Divisi Pendidikan:</strong> Penanggung jawab operasional utama.</li>
          <li><strong>Sekretaris & Bendahara:</strong> Pengelola administrasi dan keuangan.</li>
        </ul>
      `,
    },
    en: {
      judul: "Idrisiyyah Education Organizational Structure",
      deskripsi: `
        <p>The organizational structure of the Idrisiyyah Education Division is designed to ensure professional, transparent, and accountable institutional governance.</p>
        <br/>
        <h3>Main Structure</h3>
        <ul>
          <li><strong>Head of Education Division:</strong> Main operational person in charge.</li>
          <li><strong>Secretary & Treasurer:</strong> Administrative and financial managers.</li>
        </ul>
      `,
    },
    ar: {
      judul: "الهيكل التنظيمي لتعليم إدريسية",
      deskripsi: `
        <p>تم تصميم الهيكل التنظيمي لقسم التعليم في إدريسية لضمان حوكمة مؤسسية مهنية وشفافة وخاضعة للمساءلة.</p>
        <br/>
        <h3>الهيكل الرئيسي</h3>
        <ul>
          <li><strong>رئيس قسم التعليم:</strong> المسؤول التشغيلي الرئيسي.</li>
          <li><strong>السكرتير وأمين الصندوق:</strong> مدراء الإدارة والشؤون المالية.</li>
        </ul>
      `,
    },
  },
};

export const DUMMY_BERITA = {
  id: [
    {
      _id: "news-1",
      judul: "Pendaftaran Siswa Baru SMPIT Idrisiyyah 2024/2025",
      tanggal: "01 Maret 2024",
      waktu: "08:00",
      penulis: "Humas Pendidikan",
      gambar: "/idrisiyyahtumbnail.png",
      deskripsi:
        "Pendaftaran peserta didik baru untuk jenjang SMPIT Idrisiyyah telah resmi dibuka.",
    },
    {
      _id: "news-2",
      judul: "Wisuda Tahfidz: Mencetak Generasi Penjaga Al-Qur'an",
      tanggal: "25 Februari 2024",
      waktu: "09:00",
      penulis: "Panitia Wisuda",
      gambar: "/idrisiyyahtumbnail.png",
      deskripsi: "Siswa Pesantren Idrisiyyah mengikuti prosesi wisuda tahfidz.",
    },
    {
      _id: "news-3",
      judul: "Seminar Pendidikan Karakter di Era Digital",
      tanggal: "10 Maret 2024",
      waktu: "10:00",
      penulis: "Humas Pendidikan",
      gambar: "/idrisiyyahtumbnail.png",
      deskripsi:
        "Seminar ini membahas tantangan dan solusi pendidikan karakter bagi santri di era teknologi.",
    },
    {
      _id: "news-4",
      judul: "Kunjungan Studi Banding Pesantren Se-Jawa Barat",
      tanggal: "15 Maret 2024",
      waktu: "09:00",
      penulis: "Bagian Akademik",
      gambar: "/idrisiyyahtumbnail.png",
      deskripsi:
        "Delegasi dari berbagai pesantren mengunjungi Idrisiyyah untuk berbagi praktik terbaik pendidikan.",
    },
    {
      _id: "news-5",
      judul: "Juara Umum PORSENI Tingkat Kabupaten",
      tanggal: "20 Maret 2024",
      waktu: "15:00",
      penulis: "Kesiswaan",
      gambar: "/idrisiyyahtumbnail.png",
      deskripsi:
        "Santri Idrisiyyah berhasil meraih predikat juara umum dalam ajang PORSENI tahun ini.",
    },
  ],
  en: [
    {
      _id: "news-1",
      judul: "New Student Registration SMPIT Idrisiyyah 2024/2025",
      tanggal: "March 01, 2024",
      waktu: "08:00",
      penulis: "Education PR",
      gambar: "/idrisiyyahtumbnail.png",
      deskripsi:
        "Registration for new students at SMPIT Idrisiyyah level has officially opened.",
    },
    {
      _id: "news-2",
      judul: "Tahfidz Graduation: Producing Quran Guardian Generation",
      tanggal: "February 25, 2024",
      waktu: "09:00",
      penulis: "Graduation Committee",
      gambar: "/idrisiyyahtumbnail.png",
      deskripsi:
        "Students of Idrisiyyah Pesantren participated in the tahfidz graduation ceremony.",
    },
    {
      _id: "news-3",
      judul: "Character Education Seminar in the Digital Era",
      tanggal: "March 10, 2024",
      waktu: "10:00",
      penulis: "Education PR",
      gambar: "/idrisiyyahtumbnail.png",
      deskripsi:
        "This seminar discusses challenges and solutions for character education in the technology era.",
    },
    {
      _id: "news-4",
      judul: "Comparative Study Visit of Pesantrens Across West Java",
      tanggal: "March 15, 2024",
      waktu: "09:00",
      penulis: "Academic Dept",
      gambar: "/idrisiyyahtumbnail.png",
      deskripsi:
        "Delegations from various pesantrens visited Idrisiyyah to share educational best practices.",
    },
    {
      _id: "news-5",
      judul: "General Champion of District Level Sports and Arts Week",
      tanggal: "March 20, 2024",
      waktu: "15:00",
      penulis: "Student Affairs",
      gambar: "/idrisiyyahtumbnail.png",
      deskripsi:
        "Idrisiyyah students successfully won the general champion title in this year's PORSENI event.",
    },
  ],
  ar: [
    {
      _id: "news-1",
      judul: "تسجيل الطلاب الجدد لمدرسة SMPIT إدريسية 2024/2025",
      tanggal: "01 مارس 2024",
      waktu: "08:00",
      penulis: "العلاقات العامة للتعليم",
      gambar: "/idrisiyyahtumbnail.png",
      deskripsi:
        "تم فتح باب التسجيل للطلاب الجدد في مدرسة SMPIT إدريسية رسمياً.",
    },
    {
      _id: "news-2",
      judul: "حفل تخرج حفظة القرآن: تخريج جيل حافظ للقرآن",
      tanggal: "25 فبراير 2024",
      waktu: "09:00",
      penulis: "لجنة التخرج",
      gambar: "/idrisiyyahtumbnail.png",
      deskripsi: "شارك طلاب معهد إدريسية في حفل تخرج حفظة القرآن الكريم.",
    },
    {
      _id: "news-3",
      judul: "ندوة تعليم الشخصية في العصر الرقمي",
      tanggal: "10 مارس 2024",
      waktu: "10:00",
      penulis: "العلاقات العامة للتعليم",
      gambar: "/idrisiyyahtumbnail.png",
      deskripsi:
        "تناقش هذه الندوة تحديات وحلول تعليم الشخصية للطلاب في عصر التكنولوجيا.",
    },
    {
      _id: "news-4",
      judul: "زيارة دراسية مقارنة للمعاهد الإسلامية في جاوا الغربية",
      tanggal: "15 مارس 2024",
      waktu: "09:00",
      penulis: "القسم الأكاديمي",
      gambar: "/idrisiyyahtumbnail.png",
      deskripsi:
        "قامت وفود من مختلف المعاهد بزيارة إدريسية لتبادل أفضل الممارسات التعليمية.",
    },
    {
      _id: "news-5",
      judul: "البطل العام لأسبوع الرياضة والفنون على مستوى المنطقة",
      tanggal: "20 مارس 2024",
      waktu: "15:00",
      penulis: "شؤون الطلاب",
      gambar: "/idrisiyyahtumbnail.png",
      deskripsi:
        "نجح طلاب إدريسية في الفوز بلقب البطل العام في مهرجان PORSENI لهذا العام.",
    },
  ],
};

export const DUMMY_ARTIKEL = {
  id: [
    {
      _id: "article-1",
      judul_artikel: "Adab Sebelum Ilmu: Pondasi Pendidikan di Idrisiyyah",
      tanggal: "12 Maret 2024",
      waktu: "10:00",
      narasumber: "Syaikh Muhammad Fathurahman",
      gambar: "/idrisiyyahtumbnail.png",
      deskripsi: "Dalam tradisi pesantren, adab mendahului ilmu.",
    },
    {
      _id: "article-2",
      judul_artikel: "Pentingnya Adab terhadap Guru",
      tanggal: "14 Maret 2024",
      waktu: "13:00",
      narasumber: "Ust. Ahmad Fauzi",
      gambar: "/idrisiyyahtumbnail.png",
      deskripsi:
        "Membahas pentingnya menghormati guru sebagai kunci keberkahan ilmu.",
    },
    {
      _id: "article-3",
      judul_artikel: "Meneladani Sifat Rasulullah dalam Keseharian",
      tanggal: "16 Maret 2024",
      waktu: "15:00",
      narasumber: "Syaikh Muhammad Fathurahman",
      gambar: "/idrisiyyahtumbnail.png",
      deskripsi:
        "Bagaimana mengaplikasikan akhlak Rasulullah dalam kehidupan modern.",
    },
    {
      _id: "article-4",
      judul_artikel: "Manfaat Puasa bagi Kesehatan Jasmani dan Rohani",
      tanggal: "18 Maret 2024",
      waktu: "09:00",
      narasumber: "Dr. Zulfikar",
      gambar: "/idrisiyyahtumbnail.png",
      deskripsi: "Tinjauan medis dan spiritual tentang keutamaan ibadah puasa.",
    },
    {
      _id: "article-5",
      judul_artikel: "Sejarah Keemasan Islam di Bidang Sains",
      tanggal: "20 Maret 2024",
      waktu: "10:00",
      narasumber: "Prof. Abdullah",
      gambar: "/idrisiyyahtumbnail.png",
      deskripsi: "Menengok kembali kejayaan ilmuwan muslim di masa lampau.",
    },
  ],
  en: [
    {
      _id: "article-1",
      judul_artikel:
        "Adab Before Knowledge: Foundation of Education in Idrisiyyah",
      tanggal: "March 12, 2024",
      waktu: "10:00",
      narasumber: "Sheikh Muhammad Fathurahman",
      gambar: "/idrisiyyahtumbnail.png",
      deskripsi: "In pesantren tradition, manners precede knowledge.",
    },
    {
      _id: "article-2",
      judul_artikel: "The Importance of Manners Towards Teachers",
      tanggal: "March 14, 2024",
      waktu: "13:00",
      narasumber: "Ust. Ahmad Fauzi",
      gambar: "/idrisiyyahtumbnail.png",
      deskripsi:
        "Discussing the importance of respecting teachers as the key to the blessing of knowledge.",
    },
    {
      _id: "article-3",
      judul_artikel: "Emulating the Prophet's Character in Daily Life",
      tanggal: "March 16, 2024",
      waktu: "15:00",
      narasumber: "Sheikh Muhammad Fathurahman",
      gambar: "/idrisiyyahtumbnail.png",
      deskripsi: "How to apply the Prophet's character in modern life.",
    },
    {
      _id: "article-4",
      judul_artikel: "Benefits of Fasting for Physical and Spiritual Health",
      tanggal: "March 18, 2024",
      waktu: "09:00",
      narasumber: "Dr. Zulfikar",
      gambar: "/idrisiyyahtumbnail.png",
      deskripsi:
        "Medical and spiritual review of the virtues of fasting worship.",
    },
    {
      _id: "article-5",
      judul_artikel: "The Golden History of Islam in the Field of Science",
      tanggal: "March 20, 2024",
      waktu: "10:00",
      narasumber: "Prof. Abdullah",
      gambar: "/idrisiyyahtumbnail.png",
      deskripsi: "Looking back at the glory of Muslim scientists in the past.",
    },
  ],
  ar: [
    {
      _id: "article-1",
      judul_artikel: "الأدب قبل العلم: أساس التعليم في إدريسية",
      tanggal: "١٢ مارس ٢٠٢٤",
      waktu: "١٠:٠٠",
      narasumber: "الشيخ محمد فتح الرحمن",
      gambar: "/idrisiyyahtumbnail.png",
      deskripsi: "في تقاليد المعاهد الإسلامية، الأدب يسبق العلم.",
    },
    {
      _id: "article-2",
      judul_artikel: "أهمية الأدب مع المعلمين",
      tanggal: "١٤ مارس ٢٠٢٤",
      waktu: "١٣:٠٠",
      narasumber: "الأستاذ أحمد فوزي",
      gambar: "/idrisiyyahtumbnail.png",
      deskripsi: "مناقشة أهمية احترام المعلمين كمفتاح لبركة العلم.",
    },
    {
      _id: "article-3",
      judul_artikel:
        "الاقتداء بصفات الرسول صلى الله عليه وسلم في الحياة اليومية",
      tanggal: "١٦ مارس ٢٠٢٤",
      waktu: "١٥:٠٠",
      narasumber: "الشيخ محمد فتح الرحمن",
      gambar: "/idrisiyyahtumbnail.png",
      deskripsi: "كيفية تطبيق أخلاق الرسول في الحياة الحديثة.",
    },
    {
      _id: "article-4",
      judul_artikel: "فوائد الصيام للصحة الجسدية والروحية",
      tanggal: "١٨ مارس ٢٠٢٤",
      waktu: "٠٩:٠٠",
      narasumber: "الدكتور ذو الفقار",
      gambar: "/idrisiyyahtumbnail.png",
      deskripsi: "مراجعة طبية وروحية لفضائل عبادة الصيام.",
    },
    {
      _id: "article-5",
      judul_artikel: "التاريخ الذهبي للإسلام في مجال العلوم",
      tanggal: "٢٠ مارس ٢٠٢٤",
      waktu: "١٠:٠٠",
      narasumber: "الأستاذ عبد الله",
      gambar: "/idrisiyyahtumbnail.png",
      deskripsi: "نظرة إلى الوراء على مجد العلماء المسلمين في الماضي.",
    },
  ],
};

export const DUMMY_AGENDA = {
  id: [
    {
      _id: "agenda-1",
      title: "Pendaftaran Peserta Didik Baru (PPDB) 2024",
      tanggal: "01 Mei 2024",
      waktu: "08:00",
      lokasi: "Kantor Pusat Pendidikan",
      deskripsi: "Pembukaan pendaftaran santri baru untuk semua jenjang.",
    },
    {
      _id: "agenda-2",
      title: "Ujian Akhir Semester (UAS) Genap",
      tanggal: "10 Juni 2024",
      waktu: "07:30",
      lokasi: "Ruang Kelas Masing-masing",
      deskripsi: "Pelaksanaan evaluasi belajar akhir semester genap.",
    },
    {
      _id: "agenda-3",
      title: "Wisuda & Haflatul Ikhtitam",
      tanggal: "25 Juni 2024",
      waktu: "08:00",
      lokasi: "Aula Utama Pesantren",
      deskripsi: "Upacara kelulusan dan pelepasan santri tingkat akhir.",
    },
    {
      _id: "agenda-4",
      title: "Pertemuan Wali Santri & Pembagian Raport",
      tanggal: "30 Juni 2024",
      waktu: "09:00",
      lokasi: "Gedung Serba Guna",
      deskripsi: "Evaluasi hasil belajar bersama orang tua/wali santri.",
    },
    {
      _id: "agenda-5",
      title: "Masa Ta'aruf Siswa Baru (MATSAMA)",
      tanggal: "15 Juli 2024",
      waktu: "07:00",
      lokasi: "Lapangan Utama",
      deskripsi: "Pengenalan lingkungan pesantren untuk santri baru.",
    },
  ],
  en: [
    {
      _id: "agenda-1",
      title: "New Student Admission (PPDB) 2024",
      tanggal: "May 01, 2024",
      waktu: "08:00",
      lokasi: "Education Head Office",
      deskripsi: "Opening of registration for new students for all levels.",
    },
    {
      _id: "agenda-2",
      title: "Even Semester Final Examination (UAS)",
      tanggal: "June 10, 2024",
      waktu: "07:30",
      lokasi: "Respective Classrooms",
      deskripsi:
        "Implementation of the even semester final learning evaluation.",
    },
    {
      _id: "agenda-3",
      title: "Graduation & Haflatul Ikhtitam",
      tanggal: "June 25, 2024",
      waktu: "08:00",
      lokasi: "Main Hall of Pesantren",
      deskripsi: "Graduation ceremony and farewell for final year students.",
    },
    {
      _id: "agenda-4",
      title: "Parent-Teacher Meeting & Report Card Distribution",
      tanggal: "June 30, 2024",
      waktu: "09:00",
      lokasi: "Multipurpose Building",
      deskripsi: "Evaluating learning outcomes with parents/guardians.",
    },
    {
      _id: "agenda-5",
      title: "New Student Orientation (MATSAMA)",
      tanggal: "July 15, 2024",
      waktu: "07:00",
      lokasi: "Main Field",
      deskripsi: "Introduction to the pesantren environment for new students.",
    },
  ],
  ar: [
    {
      _id: "agenda-1",
      title: "تجيل الطلاب الجدد (PPDB) ٢٠٢٤",
      tanggal: "٠١ مايو ٢٠٢٤",
      waktu: "٠٨:٠٠",
      lokasi: "المكتب الرئيسي للتعليم",
      deskripsi: "افتتاح التسجيل للطلاب الجدد لجميع المستويات.",
    },
    {
      _id: "agenda-2",
      title: "امتحان نهاية الفصل الدراسي الثاني (UAS)",
      tanggal: "١٠ يونيو ٢٠٢٤",
      waktu: "٠٧:٣٠",
      lokasi: "الفصول الدراسية لكل منها",
      deskripsi: "تنفيذ تقييم التعلم النهائي للفصل الدراسي الثاني.",
    },
    {
      _id: "agenda-3",
      title: "حفل التخرج وحفلة الاختتام",
      tanggal: "٢٥ يونيو ٢٠٢٤",
      waktu: "٠٨:٠٠",
      lokasi: "القاعة الرئيسية للمعهد",
      deskripsi: "حفل التخرج ووداع طلاب السنة النهائية.",
    },
    {
      _id: "agenda-4",
      title: "اجتماع أولياء الأمور وتوزيع الشهادات",
      tanggal: "٣٠ يونيو ٢٠٢٤",
      waktu: "٠٩:٠٠",
      lokasi: "مبنى متعدد الأغراض",
      deskripsi: "تقييم نتائج التعلم مع أولياء الأمور.",
    },
    {
      _id: "agenda-5",
      title: "فترة تعريف الطلاب الجدد (MATSAMA)",
      tanggal: "١٥ يوليو ٢٠٢٤",
      waktu: "٠٧:٠٠",
      lokasi: "الميدان الرئيسي",
      deskripsi: "مقدمة لبيئة المعهد للطلاب الجدد.",
    },
  ],
};

export const DUMMY_IKLAN = [
  {
    _id: "ads-1",
    judul: "Dukung Penyebaran Dakwah Islam",
    judulEng: "Support the Spread of Islamic Da'wah",
    judulArab: "دعم نشر الدعوة الإسلامية",
    ukuran: "1110",
    gambar: "https://placehold.co/1110x400/grey/white?text=Iklan+1110x400",
    url: "https://idrisiyyah.or.id",
    sumber: "Humas Idrisiyyah",
    tanggal: "27 Agustus 2024",
  },
  {
    _id: "ads-2",
    judul: "Pendaftaran Ma'had Aly Idrisiyyah",
    judulEng: "Ma'had Aly Idrisiyyah Registration",
    judulArab: "تسجيل معهد عالي إدريسية",
    ukuran: "850",
    gambar: "https://placehold.co/850x450/grey/white?text=Iklan+850x450",
    url: "https://idrisiyyah.or.id",
    sumber: "Pendidikan Idrisiyyah",
    tanggal: "27 Agustus 2024",
  },
];

export const DUMMY_PRESTASI = [
  {
    _id: "prestasi-1",
    judul: "Juara 1 Lomba Pidato Bahasa Arab Nasional",
    tanggal: "10 Januari 2024",
    gambar: "/idrisiyyahtumbnail.png",
    deskripsi:
      "Santri MTS Idrisiyyah meraih juara pertama dalam ajang perlombaan pidato bahasa Arab tingkat nasional.",
  },
];

export const DUMMY_KARYA_SISWA = [
  {
    _id: "karya-1",
    judul: "Antologi Puisi Santri Milenial",
    tanggal: "05 April 2024",
    gambar: "/idrisiyyahtumbnail.png",
    deskripsi:
      "Kumpulan puisi karya siswa-siswi MTS Idrisiyyah yang bertemakan spiritualitas dan kehidupan pesantren.",
  },
];

export const DUMMY_SARANA_PRASARANA = [
  {
    _id: "sapras-1",
    judul: "Gedung Belajar Representatif",
    tanggal: "01 Januari 2024",
    gambar: "/idrisiyyahtumbnail.png",
    deskripsi:
      "Ruang kelas yang nyaman dan kondusif untuk proses belajar mengajar.",
  },
];

export const DUMMY_PROGRAM_UNGGULAN = [
  {
    _id: "prog-1",
    judul: "Tahfidzul Qur'an & Tartil",
    tanggal: "Harian",
    penulis: "Divisi Keagamaan",
    gambar: "/idrisiyyahtumbnail.png",
    deskripsi:
      "Program unggulan untuk mencetak generasi penghafal Al-Qur'an dengan bacaan yang tartil dan fasih.",
  },
];
